import { GraphQLClient } from 'graphql-request';
import { graphQLRequest } from '../graphQL/graphQLRequestModule';
import { getInvestorFilesByIdQuery } from '../graphQL/queries/operatorPortal/files/getInvestorFilesByIdQuery';
import { GetInvestorDraftFilesInput } from 'src/generated/graphql-types';
import { UserRolesEnum } from 'src/types.d';

/**
 * GraphQL request for the investor personal files
 * @param token Given auth token
 * @param client GraphQL client
 * @param id Legal entity id of the investor
 * @returns Files of the requested id
 */
export async function getInvestorDraftFilesById(
  token: string,
  client: GraphQLClient,
  legalEntityIds: string[],
): Promise<any> {
  //add open record to the filter request

  //create input variable for the GQL request
  const input: GetInvestorDraftFilesInput = {
    legalEntityIds,
  };
  let variables = {
    input,
  };

  //send GQL request for the overview data
  const res = await graphQLRequest(
    token,
    client,
    getInvestorFilesByIdQuery,
    variables,
    UserRolesEnum.operator,
  );

  return res;
}
